import ExpenseEditComponent from '../../components/expenses/ExpenseEditComponent';
import { Expense, updateExpenseAsync } from '../../modules/expenses';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { Drawer } from 'antd';
import { useEffect, useState } from 'react';
import { getExpenseCommon } from '../../api/constlink';

interface ExpenseEditDrawerProps {
  config: any;
  expense: Expense;
  visible: boolean;
  onClose: () => void;
}

function ExpenseEditDrawer({
  config,
  expense,
  visible,
  onClose,
}: ExpenseEditDrawerProps) {
  const [expenseCommon, setExpenseCommon] = useState<any>();

  useEffect(() => {
    (async () => {
      const expenseCommon = await getExpenseCommon(config.enterpriseId);
      setExpenseCommon({
        ...expenseCommon,
      });
    })();
  }, [config]);

  const dispatch = useDispatch();

  const onUpdate = async (data: any) => {
    const expense = {
      ...data,
      usedDateTime: moment(data.usedDateTime).format('YYYY-MM-DD HH:mm'),
    };

    if (data.project) expense.projectId = data.project.id;
    if (data.usedBy) expense.usedById = data.usedBy.id;
    if (data.gongjong === undefined) expense.gongjong = null;

    dispatch(updateExpenseAsync.request({ ...config, expense }));
    onClose();
  };

  return (
    <>
      {expense && expenseCommon && (
        <Drawer
          width={600}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          {visible && (
            <ExpenseEditComponent
              onUpdate={onUpdate}
              onCancel={onClose}
              expense={expense}
              expenseCommon={expenseCommon}
            />
          )}
        </Drawer>
      )}
    </>
  );
}

export default ExpenseEditDrawer;
